import { useContext } from 'react';
import c from '../../utils/c';
import { SlideViewerContext } from './SlideViewerContextProvider';
import useFormatMessage from '../../hooks/useFormatMessage';
import { dataTestIds } from '../../utils/constants/dataTestIds';

/**
 * When the current slide is the last slide,
 * you can't go further right and the right actions should be disabled
 *
 * @param {Array} slides
 * @param {number} currentSlideIndex
 * @returns boolean
 */
export function isRightActionDisabled(slides, currentSlideIndex) {
  const isDisabled = currentSlideIndex === slides.length - 1;

  return isDisabled;
}

export default function SlideViewerRightAction({ children, className }) {
  const t = useFormatMessage();

  const {
    currentSlideIndex,
    setShowConfirmationDialog,
    setSlide,
    showConfirmationDialog,
    slides,
    submitAnswer,
  } = useContext(SlideViewerContext);

  const disabled = isRightActionDisabled(slides, currentSlideIndex);

  return (
    <button
      aria-label={t('styled-slide-viewer.next')}
      className={c(
        'slideviewerSlideRight',
        className,
        !disabled && 'text-gray-400 hover:text-black',
        disabled &&
          !showConfirmationDialog &&
          'text-gray-100 cursor-not-allowed',
      )}
      data-test={dataTestIds.component.slideviewer.slide.button.right}
      disabled={disabled || showConfirmationDialog}
      onClick={() => {
        if (submitAnswer) {
          setShowConfirmationDialog(true);
        } else {
          setSlide(currentSlideIndex + 1);
        }
      }}
      type="button"
    >
      {children}
    </button>
  );
}
